import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/pt";

dayjs.extend(relativeTime);
dayjs.locale("pt");

export function fmtDateTime(iso) {
  if (!iso) return "—";
  const d = dayjs(iso);
  if (!d.isValid()) return "—";
  return d.format("YYYY-MM-DD HH:mm");
}

export function fmtDate(iso) {
  if (!iso) return "—";
  const d = dayjs(iso);
  if (!d.isValid()) return "—";
  return d.format("YYYY-MM-DD");
}

export function fmtRelative(iso) {
  if (!iso) return "—";
  const d = dayjs(iso);
  if (!d.isValid()) return "—";
  return d.fromNow();
}

export function feedbackBucket(lastIso) {
  if (!lastIso) return "none";
  const hours = (Date.now() - new Date(lastIso).getTime()) / 36e5;
  if (hours < 48) return "green";
  if (hours < 72) return "yellow";
  return "red";
}

export function escalationLevel(deadlineIso, status) {
  if (!deadlineIso) return 0;
  if (["Concluída", "Cancelada"].includes(status)) return 0;
  const hrs = (Date.now() - new Date(deadlineIso).getTime()) / 36e5;
  if (hrs < 0) return 0;
  if (hrs >= 168) return 5;
  if (hrs >= 96) return 4;
  if (hrs >= 72) return 3;
  if (hrs >= 48) return 2;
  if (hrs >= 24) return 1;
  return 0;
}

export function toCSV(rows, headers) {
  const head = headers.map((h) => h.label).join(",");
  const lines = rows.map((r) =>
    headers
      .map((h) => {
        const val = r[h.key];
        if (val == null) return "";
        const s = String(val).replace(/"/g, '""');
        return /[,"\n]/.test(s) ? `"${s}"` : s;
      })
      .join(",")
  );
  return [head, ...lines].join("\n");
}

export function downloadCSV(filename, csv) {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
